import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';
import { Table} from 'react-bootstrap';
import {distributionReturnedGet} from '../../../libs/services';

class ModalDetails extends Component{
	constructor(props) {
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
		    show: false,
            units:[],
            date_hour:"",
            number:"",
            observations:"",
            user:"",
            reason:""
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ 
            show: false,
            units:[],
            date_hour:"",
            number:"",
            observations:"",
            user:"",
            reason:""
        });
	}

	async handleShow(id) {
        var response = await distributionReturnedGet(id, this.props.waiting);

        if(response !== undefined){
            this.setState({
                show:true,
                date_hour: moment(response.timestamp).format('DD/MM/YYYY'),
                number:response.id,
                user: response.user_name,
                reason:response.reason,
                observations: response.observations,
                units: response.units
            });
        }
	}


	render(){
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles Devolición de Componentes</Modal.Title>
		        </Modal.Header>
		        <Modal.Body>
				    <div className="row"> 
                        <div className='col-xs-12'>
                            <div className='col-xs-12 col-sm-4'>Fecha y Hora</div>
                            <div className='col-xs-12 col-sm-8'>{this.state.date_hour}</div>
                        </div>
                        <div className='col-xs-12'>
                            <div className='col-xs-12 col-sm-4'>No. Devolución</div>
                            <div className='col-xs-12 col-sm-8'>{this.state.number}</div>
                        </div>
                        <div className='col-xs-12'>
                            <div className='col-xs-12 col-sm-4'>Usuario</div>
                            <div className='col-xs-12 col-sm-8'>{this.state.user}</div>
                        </div>
                        <div className='col-xs-12'>
                            <div className='col-xs-12 col-sm-4'>Motivo Devolición</div>
                            <div className='col-xs-12 col-sm-8'>{this.state.reason}</div>
                        </div>
                        <div className='col-xs-12 form-group'>
                            <div className='col-xs-12 col-sm-4'>Observaciones</div>
                            <div className='col-xs-12 col-sm-8'>{this.state.observations}</div>
                        </div>
                        <div className='col-xs-12'>
                            <Table responsive hover style={{margin:"0px"}}>
                                <thead>
                                    <tr>
                                        <th>No. Unidad</th>
                                        <th>Folio de Envío</th>
                                        <th>Fecha de Envío</th>
                                        <th >Código Componente</th>
                                        <th>No. Componente</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.units.map( (unit, index) => (
                                        <tr key={index}>
                                            <td>{unit.unit_number}</td>
                                            <td>{unit.folio}</td>
                                            <td>{moment(unit.shipping_date).format('DD/MM/YYYY')} </td>
                                            <td>{unit.component_code} </td>
                                            <td>{unit.component_number}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
		            </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalDetails);